import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import * as React from "react";

interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  activeChurnedType: boolean;
  disabled?: boolean;
}

class ActiveChurnedFilter extends React.Component<Props> {
  public render() {
    return (
      <FormControlLabel
        control={
          <Checkbox
            disabled={this.props.disabled}
            checked={this.props.activeChurnedType === true}
            onChange={this.props.onChange}
            value="true"
          />
        }
        label={<FormLabel component="div">Aktiv aber gekündigt</FormLabel>}
      />
    );
  }
}

export default ActiveChurnedFilter;



// WEBPACK FOOTER //
// ./src/components/ActiveChurnedFilter.tsx